export default (response = {}) => {
  return response.errors ?
    Promise.reject(new Error(`[GraphQL response errors] ${JSON.stringify(response.errors)}`)) :
    Promise.resolve(response)
}
